import { useState, useEffect, useContext } from 'react'
import GlobalContext from '../../../context/global-context'
import CustomButton from '../ui/CustomButton'
import { optionTipoComprobante, optionEstado } from '../data/dataComprobante'
import TablaNuevoComprobante from '../views/dashboard/MiContador/Comprobante/TablaNuevoComprobante'
import { OrganizationAPI } from '../../../api/organization.api'
import FilterControl from '../table/FilterControl'
import FilterDateControl from '../table/FilterDateControl'
import ResizableModal from '../ui/ResizableModal'
import { Title } from '../ui'

const ModalEditMiContador = ({openModal,setOpenModal,comprobanteId,validation,createUserId,listaDataAuxiliar,onClose,setSwitchGetData,glosaInitial = '',nComprobante}) => {
  const [totalDebe, setTotalDebe] = useState(0)
  const [totalHaber, setTotalHaber] = useState(0)
  const [selectedDate, setSelectedDate] = useState('')
  const [tipoComprobante, setTipoComprobante] = useState('')
  const [estadoComprobante, setEstadoComprobante] = useState(0)
  const [libros, setLibros] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [glosa, setGlosa] = useState(glosaInitial)
  const organizationAPI = new OrganizationAPI()
  const { ui, currentBusiness } = useContext(GlobalContext)
  const [data, setData] = useState()
  const [isBorrador, setIsBorrador] = useState(false)
  const [switchDate, setSwitchDate] = useState(true)
  const [razonSocial, setRazonSocial] = useState('')
  const [rut, setRut] = useState('')
  const [nombreComprobante, setNombreComprobante] = useState('')
  const [vencimiento, setVencimiento] = useState('')
  const [folio, setFolio] = useState('')
  const [listaAuxiliar, setListaAuxiliar] = useState([])

  const getDateToUse = () => {
    return switchDate && selectedDate ? selectedDate : new Date().toISOString().split('T')[0]
  }

  const handleClose = () => { setOpenModal(false) }
  
    const handleDateChange = (value) => {
      const selectedDate = new Date(value)
      const today = new Date()
      const minDate = new Date('2024-01-01')
    
      if (selectedDate >= minDate && selectedDate <= today) {
        setSelectedDate(value)
      } else {
        setSelectedDate('')
      }
    }
  
    const handleTextareaChange = (e) => {
      const value = e.target.value
      if (value.length > 50) {
        setErrorMessage('Máximo 50 caracteres permitidos')
      } else {
        setErrorMessage('')
      }
      setGlosa(value)
      setLibros((prevLibros) =>
        prevLibros.map((row) => ({
          ...row,
          glosa: row.glosa === glosa ? value : row.glosa,
        }))
      )
    }

    useEffect(() => {
      const fetchData = async () => {
        try {
          ui.setLoader({ visible: true})
          let response
          if (validation >= 0) {
            setIsBorrador(false)
            response = await organizationAPI.getComprobanteEdit({
              businessId: currentBusiness.id,
              comprobanteId,
            })
          } else if (validation === -6) {
            setIsBorrador(true)
            response = await organizationAPI.getComprobanteBorrador({
              businessId: currentBusiness.id,
              comprobanteId,
            })
          }
          const data = response?.data || {}
          const librosProcesados = data?.libros?.map((libro) => {
            return {
              debe: libro.debe || 0,
              haber: libro.haber || 0,
              glosa: libro.glosa || '',
              codigoCuenta: libro.cuentaContable?.codigoCuenta || libro.codigoCuenta || '',
              nombreCuenta: libro.cuentaContable?.nombreCuenta || libro.nombreCuenta || '',
              cuentaContableId: libro.cuentaContableId || libro.cuentaContable?.id || null,
              tipoComprobanteId: libro.tipoComprobanteId || null,
              id: libro.id || null
            }
          }) || []
          const tipoComprobanteId = librosProcesados[0]?.tipoComprobanteId || null
          const ids = librosProcesados.map((libro) => libro.id)
          const fechaProcesada = data?.fecha ? new Date(data.fecha) : null
          const vencimientoProcesado = data?.vencimiento
          ? new Date(data.vencimiento).toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' })
          : ''
  
        setData({
          ...data,
          libros: librosProcesados,
          tipoComprobanteId,
          fecha: fechaProcesada,
          vencimiento: vencimientoProcesado,
          ids
        })
          setSwitchDate(true)
        } catch (error) {
          console.error(error)
        } finally {
          ui.setLoader({ visible: false})
        }
      }
    
      if (comprobanteId) {
        fetchData()
      }
    }, [comprobanteId, validation])

    const formatDate = (isoString) => {
      if (!isoString) return ''
      const date = new Date(isoString)
      return date.toISOString().split('T')[0]
    }

    const formatDateToDDMMYYYY = (dateString) => {
      if (!dateString) return ''
      const date = new Date(dateString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    }

    const mapTipoComprobante = (label) => {
      const option = optionTipoComprobante.find(opt => opt.label?.toLowerCase() === label?.toLowerCase())
      return option ? option.value : ''
    }

    const getSingleFolioValue = (value) => {
      if (Array.isArray(value)) {
        const firstValidFolio = value.find(item => String(item || '').trim() !== '')
        return firstValidFolio ? String(firstValidFolio) : ''
      }
      return value ?? ''
    }

    useEffect(() => {
      if (data) {
        setSelectedDate(formatDate(data.fecha))
        setGlosa(typeof data.glosa === 'string' ? data.glosa : glosaInitial)
        setTipoComprobante(mapTipoComprobante(data.tipoComprobante) || data.tipoComprobanteId || '')
        setEstadoComprobante(data.estado)
        setRazonSocial(data.razonSocial)
        setRut(data.rut)
        setNombreComprobante(data.nombreComprobante || data.tipoComprobanteManual || '')
        setVencimiento(formatDateToDDMMYYYY(data.vencimiento))
        setFolio(data.folio)
      }
    }, [data])
    
    const handleSubmit = async () => {
      const ids = data?.ids || []
      const payload = {
        data: libros.map((row, index) => ({
          cuentaContableId: row.cuentaContableId ? Number(row.cuentaContableId) : '',
          id: ids[index],
          glosa: row.glosa,
        })),
        glosa: glosa || '',
      }
      try {
        ui.setLoader({ visible: true})
        const response = await organizationAPI.patchComprobante(
          currentBusiness.id,
          payload
        )
        setData(response)
        setSwitchGetData(true)
        handleClose()
      } catch (error) {
        console.error('Error al guardar:', error)
      } finally {
        ui.setLoader({ visible: false})
      }
    }

    const generatePayload = ({ singleFolio = false } = {}) => {
      let vencimiento = data?.vencimiento || "";
      if (vencimiento) {
        const vencimientoDate = new Date(vencimiento.split("-").reverse().join("-"));
        vencimiento = vencimientoDate.toISOString().split("T")[0];
      }
      const rawFolio = listaAuxiliar[0]?.folio ?? folio ?? data?.folio ?? ''
      return {
        fecha: getDateToUse(),
        tipo: parseInt(tipoComprobante),
        estado: parseInt(estadoComprobante),
        glosa: glosa,
        libros: libros.map((row) => ({
          cuentaContableId: row.cuentaContableId || data?.libros?.[0]?.cuentaContableId,
          glosa: row.glosa || glosa,
          debe: parseFloat(row.debe) || 0,
          haber: parseFloat(row.haber) || 0,
          centroCosto: row.centroCostos || null,
          sucursal: row.sucursal || null,
        })),
        nombreComprobante:
          listaAuxiliar?.[0]?.nombreComprobante ||
          nombreComprobante ||
          data?.nombreComprobante ||
          null,
        vencimiento: vencimiento || "",
        folio: singleFolio ? getSingleFolioValue(rawFolio) : rawFolio,
        razonSocial: listaAuxiliar[0]?.razonSocial || razonSocial || data?.razonSocial,
        rut: listaAuxiliar[0]?.rut || rut || data?.rut,
      };
    }

    const handleBorrador = async () => {
      if (parseInt(estadoComprobante) === 1) {
          if (!selectedDate || !tipoComprobante || !glosa || totalDebe === 0 || totalHaber === 0 || totalDebe !== totalHaber) {
              setErrorMessage('Todos los campos son obligatorios.')
              return
          }
          const librosActualizados = libros.map((row) => ({
              ...row,
              isDisabled: !row.codigoCuenta?.startsWith('3'),
          }))
          setLibros(librosActualizados)
      }
      try {
        const payload = generatePayload({
          singleFolio: validation === -6 && parseInt(estadoComprobante) === 1
        })
          ui.setLoader({ visible: true})
          const response = await organizationAPI.updateBorrador(
            currentBusiness.id,
            comprobanteId,
            payload,
          )
          setData(response)
          setSwitchGetData(true)
          handleClose()
      } catch (error) {
          console.error('Error al guardar:', error)
      } finally {
        ui.setLoader({ visible: false})
      }
    }

    const handleAprobado = async () => {
      if (parseInt(estadoComprobante) === 1) {
          if (!selectedDate || !tipoComprobante || !glosa || totalDebe === 0 || totalHaber === 0 || totalDebe !== totalHaber) {
              setErrorMessage('Todos los campos son obligatorios.')
              return
          }
          const librosActualizados = libros.map((row) => ({
              ...row,
              isDisabled: !row.codigoCuenta?.startsWith('3'),
          }))
          setLibros(librosActualizados)
      }
      try {
        const payload = generatePayload()
          ui.setLoader({ visible: true})
          const response = await organizationAPI.updateAprobado(
            currentBusiness.id,
            comprobanteId,
            payload,
          )
          setData(response)
          setSwitchGetData(true)
          handleClose()
      } catch (error) {
          console.error('Error al guardar:', error)
      } finally {
        ui.setLoader({ visible: false})
      }
    }

    const handleSave = async () => {
      try {
        if (validation === 0) {
          await handleSubmit()
        } else if (validation === -6) {
          await handleBorrador()
        } else if (validation === 1) {
          await handleAprobado()
        }
        handleClose()
        if (onClose) {
          onClose()
        }
      } catch (error) {
        console.error("Error al guardar:", error);
      }
    };    

    /*const handleDelete = async () => {
      try {
        const payload = {
          fecha: getDateToUse(),
          tipo: parseInt(tipoComprobante),
          estado: -5,
          glosa: glosa,
          libros: libros.map(row => ({
            cuentaContableId: row.cuentaContableId || data?.libros?.[0]?.cuentaContableId,
            glosa: row.glosa || glosa,
            debe: parseFloat(row.debe) || 0,
            haber: parseFloat(row.haber) || 0,
            centroCosto: row.centroCostos || null,
            sucursal: row.sucursal || null,
          })),
          vencimiento: data.vencimiento,
          folio: data.folio,
          razonSocial: data.razonSocial,
          nombreComprobante: data.nombreComprobante,
          rut: data.rut,
        }
        if (validation >= 0) {
          const libroPayload = {
            cuentaContableId: data?.libros?.[0]?.cuentaContableId,
            validation: -5,
            glosa: '',
            vencimiento: data?.vencimiento,
          }
          ui.setLoader({ visible: true})
          const response = await organizationAPI.updateLibroContable(currentBusiness.id, comprobanteId, libroPayload)
          setData(response)
        } else if (validation === -6) {
          ui.setLoader({ visible: true})
          const response = await organizationAPI.updateBorrador(currentBusiness.id, comprobanteId, payload)
          setData(response)
        }
    
        handleClose()
      } catch (error) {
        console.error('Error al procesar:', error)
      } finally {
        ui.setLoader({ visible: false})
      }
    }*/

    //const isDescartarEnabled = (validation >= 0 && data?.libros?.[0]?.haber > 0) || validation === -6
    return (
      <ResizableModal open={open} onClose={handleClose}
      footer={
        <>
          {errorMessage && <p className='text-red-500 text-sm mt-1'>{errorMessage}</p>}
            <>
                <CustomButton className='rounded-full' color='accent2' title='GUARDAR' onClick={handleSave}/>
                <CustomButton className='rounded-full' color='primary' title='CANCELAR' onClick={handleClose}/>
                {/*<CustomButton className='rounded-full' color='primary' title='DESCARTAR' onClick={handleDelete} disabled={!isDescartarEnabled}/>*/}
            </> 
        </>}
      >
            <>
              <div className='flex justify-between items-center p-4'>
                <Title className='text-3xl font-sans'>Editar Comprobante - {nComprobante}</Title>
              </div>
              <div className='p-4 mt-2 bg-white rounded-lg'>
                <div className='flex flex-wrap items-center gap-4 mt-4'>
                  <FilterDateControl
                    label='Fecha'
                    value={selectedDate}
                    onChange={handleDateChange}
                    disabled={createUserId === null}
                  />
                  <FilterControl
                    label='Tipo de Comprobante'
                    value={tipoComprobante || ''}
                    options={optionTipoComprobante || []}
                    onChange={(value) => setTipoComprobante(parseInt(value))}
                    disabled={createUserId === null}
                  />
                  <FilterControl
                    label='Estado'
                    value={estadoComprobante}
                    options={optionEstado || []}
                    onChange={(value) => setEstadoComprobante(value)}
                    disabled={createUserId === null}
                  />
                </div>
                <div className='mt-4'>
                  <label className='block text-sm font-medium text-gray-700'>Glosa</label>
                    <textarea
                      className='mt-1 w-full border-gray-300 rounded-lg shadow-sm'
                      rows='1'
                      value={glosa}
                      onChange={handleTextareaChange}
                      maxLength={50}
                      required={parseInt(estadoComprobante) === 1}
                      disabled={false}
                    ></textarea>
                  <p className='text-xs'>{glosa.length}/50</p>
                </div>
                <TablaNuevoComprobante
                  setTotalDebe={setTotalDebe}
                  setTotalHaber={setTotalHaber}
                  totalDebe={totalDebe}
                  totalHaber={totalHaber}
                  setLibros={setLibros}
                  glosaPrincipal={glosa}
                  isRequired={parseInt(estadoComprobante) === 1}
                  context="edit"
                  initialData={data?.libros || []}
                  isBorrador={isBorrador}
                  validation={validation}
                  razonSocial={data?.razonSocial || ''}
                  rut={data?.rut || ''}
                  nombreComprobante={nombreComprobante}
                  vencimiento={data?.vencimiento || vencimiento || null}
                  folio={data?.folio || ''}
                  setListaAuxiliar={setListaAuxiliar}
                  createUserId={createUserId}
                  listaDataAuxiliar={listaDataAuxiliar}
                />
                {/*{errorMessage && <p className='text-red-500 text-sm mt-1'>{errorMessage}</p>}
                  <div className='sticky bottom-0 bg-white p-4 flex justify-between items-center'>
                      <CustomButton className='rounded-full' color='accent2' title='GUARDAR' onClick={handleSave}/>
                      <CustomButton className='rounded-full' color='primary' title='CANCELAR' onClick={handleClose}/>
                      <CustomButton className='rounded-full' color='primary' title='DESCARTAR' onClick={handleDelete} disabled={!isDescartarEnabled}/>
                  </div> */}
              </div>
            </>
        </ResizableModal>
    )
}

export default ModalEditMiContador
